export const GET_ACTIONS_BY_MODULE_REQUEST = 'GET_ACTIONS_BY_MODULE_REQUEST'
export const GET_ACTIONS_BY_MODULE_SUCCESS = 'GET_ACTIONS_BY_MODULE_SUCCESS'
export const GET_ACTIONS_BY_MODULE_FAIL = 'GET_ACTIONS_BY_MODULE_FAIL'
